import { render, staticRenderFns } from "./PromotionElementSelect.vue?vue&type=template&id=a2cc23d8&scoped=true&"
import script from "./PromotionElementSelect.vue?vue&type=script&lang=js&"
export * from "./PromotionElementSelect.vue?vue&type=script&lang=js&"
import style0 from "./PromotionElementSelect.vue?vue&type=style&index=0&id=a2cc23d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cc23d8",
  null
  
)

export default component.exports